import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

const ENTER_KEY = 13;

/**
 * OptionWrapper:
 *  - Wrapper for QuestionOptions
 */
export function OptionWrapper(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.selectOption();
  };

  const onKeyDown = (event) => {
    event.keyCode === ENTER_KEY && props.selectOption();
  };

  const className = `${style.wrapper} ${props.className}`;

  return (
    <div
      className={className}
      role={!className.includes("correct") && !className.includes("incorrect") ? "checkbox" : null}
      aria-checked={className.includes("selected") ? true : false}
      tabIndex={!className.includes("correct") && !className.includes("incorrect") ? props.tabIndex : null}
      onClick={onClick}
      onKeyDown={onKeyDown}>
      {props.children}
    </div>
  );
}

OptionWrapper.propTypes = {
  /**
   * ClassName to set on Componnet
   */
  className: PropTypes.string,
  /**
   * This prop can be used to display some element
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  /**
   * Fuction to Invoke when Option is selected
   */
  selectOption: PropTypes.func,
  /**
   * TabIndex to set on Component
   */
  tabIndex: PropTypes.number,
};

OptionWrapper.defaultProps = {
  className: '',
  tabIndex: 0,
};
